import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export default function GoToActionSummary({
  nextAction,
  getActionLabelById
}) {
  return nextAction ? /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.go-to.summary",
    options: {
      actionName: /*#__PURE__*/_jsx("strong", {
        children: getActionLabelById({
          actionId: nextAction.getActionId()
        })
      })
    }
  }) : null;
}